import MpnTreeNode from "./MpnTreeNode";
import "./MpnCompositionTree.css";
import ComponentsGroupTreeNode from "./ComponentsGroupTreeNode";
import {
  ICompositionComponent,
  ICompositionMpnComponent,
  IMpnComposition,
  ITccComposition,
} from "../../../../types/data.interface";
import { CompositionType } from "../mpn-composition-modal/AddMpnCompositionModal";
import { Predicates } from "libraries/predicates/predicates";
import { HighlightsCheckType } from "./ComponentsTable";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import { useEffect } from "react";

const MpnCompositionTree = ({
  composition,
  isSummaryPage,
  isMainPage,
  isPipPage,
  duplicateActionHandler,
  changeQuantityActionHandler,
  handleRemoveNode,
  openEditModal,
  shouldIncludeSku,
  canAddSku,
  manageSkuInclusion,
  manageComponentInclusion,
  assertComponentIsIncluded,
  tccComposition,
  highlightsCheckType,
  setCompositionHasHighlights,
}: {
  composition: any;
  isSummaryPage?: boolean;
  isMainPage: boolean;
  isPipPage?: boolean;
  duplicateActionHandler?: (node_id: number) => void;
  changeQuantityActionHandler?: (node_id: number, newQuantity: number) => void;
  handleRemoveNode?: (
    node_id: number,
    compositionType: CompositionType,
  ) => void;
  openEditModal?: (
    compositionEditType: CompositionType,
    compositionEditObject: ICompositionMpnComponent | IMpnComposition,
  ) => void;

  shouldIncludeSku: boolean;
  canAddSku?: boolean;
  manageSkuInclusion: any;
  manageComponentInclusion: any;
  assertComponentIsIncluded: any;

  tccComposition?: ITccComposition[];
  highlightsCheckType?: HighlightsCheckType;
  setCompositionHasHighlights?: () => void;
}) => {
  // const { state } = useCreateMpnStore();

  const hasOnlyOneChild = (composition: IMpnComposition) => {
    let count: number = 0;
    if (composition?.skus?.length > 0) count++;
    if (composition?.mpns?.length > 0) count++;
    if (composition?.molded_components?.length > 0) count++;
    if (composition?.non_molded_components?.length > 0) count++;

    return count === 1;
  };


  return (
    <div className="sku-composition-tree-container">
      <ul
        className={`root ${hasOnlyOneChild(composition) ? "only-child" : ""}`}
      >
        <MpnTreeNode
          id={`mpn-composition-${composition?.id ?? composition?.node_id ?? "root"}`}
          mpn={composition}
          isRoot={true}
          isSummaryPage={isSummaryPage ?? false}
          isMainPage={isMainPage}
          isPipPage={isPipPage ?? false}
          addActionHandler={duplicateActionHandler}
          openEditModal={openEditModal}
          handleRemoveNode={handleRemoveNode}
          shouldIncludeSku={shouldIncludeSku}
          manageSkuInclusion={manageSkuInclusion}
          manageComponentInclusion={manageComponentInclusion}
          assertComponentIsIncluded={assertComponentIsIncluded}
          canAddSku={canAddSku}
        />
      </ul>
    </div>
  );
};

export default MpnCompositionTree;
